import { render, staticRenderFns } from "./shopifyList.vue?vue&type=template&id=5a26afd3"
import script from "./shopifyList.vue?vue&type=script&lang=js"
export * from "./shopifyList.vue?vue&type=script&lang=js"
import style0 from "./shopifyList.vue?vue&type=style&index=0&id=5a26afd3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports